import React, { useEffect, useState } from "react";
import { OneKlicksFileSDK } from "../../../../../SDK/OneKlicksFileSDK";
import { oneKlicks } from "../../../../../SDK/oneclick";
import { getuserdata } from "../../../../../services/apiService";
import { Link } from "react-router-dom";
import ImageShow from "../../../../../Uitiles/ImageShow";
import downloadImage, { extractImageUrlsFromPage } from "../../../../../Uitiles/downloadImage";

const Gallery = ({ galleryImages = [], setGalleryImages, videos = [], setVideos, newVideoUrl, setNewVideoUrl, isUploading, setIsUploading, galleryid }) => {
    // Pagination state
    const [currentImagePage, setCurrentImagePage] = useState(1);
    const [currentVideoPage, setCurrentVideoPage] = useState(1);
    const itemsPerPage = 10;
    const [importFromFB, setImportFromFB] = useState(false);
    const [fbpageurl, setFbpageurl] = useState("");
    // Parse galleryImages if it's a string, otherwise use as is
    const parseGalleryImages = (images) => {
        // Handle undefined or null
        if (!images) {
            return [];
        }
        if (typeof images === 'string') {
            try {
                const parsed = JSON.parse(images);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                console.error("Error parsing galleryImages:", e);
                return [];
            }
        }
        return Array.isArray(images) ? images : [];
    };

    // Parse videos if it's a string, otherwise use as is
    const parseVideos = (videosData) => {
        if (typeof videosData === 'string') {
            try {
                const parsed = JSON.parse(videosData);
                // Filter out any non-object items and empty arrays
                return Array.isArray(parsed) ? parsed.filter(item =>
                    typeof item === 'object' && item !== null && !Array.isArray(item)
                ) : [];
            } catch (e) {
                console.error("Error parsing videos:", e);
                return [];
            }
        }
        return Array.isArray(videosData) ? videosData.filter(item =>
            typeof item === 'object' && item !== null && !Array.isArray(item)
        ) : [];
    };

    const galleryImagesArray = parseGalleryImages(galleryImages).map((img, index) => {
        const stableId = img?.id ?? img?.fileId ?? img?.url ?? `idx-${index}`;
        return { ...img, id: stableId };
    });
    const videosArray = parseVideos(videos);

    // Pagination calculations
    const totalImagePages = Math.ceil(galleryImagesArray.length / itemsPerPage);
    const totalVideoPages = Math.ceil(videosArray.length / itemsPerPage);

    const startImageIndex = (currentImagePage - 1) * itemsPerPage;
    const endImageIndex = startImageIndex + itemsPerPage;
    const startVideoIndex = (currentVideoPage - 1) * itemsPerPage;
    const endVideoIndex = startVideoIndex + itemsPerPage;

    const currentImages = galleryImagesArray.slice(startImageIndex, endImageIndex);
    const currentVideos = videosArray.slice(startVideoIndex, endVideoIndex);

    // Pagination handlers
    const goToImagePage = (page) => {
        setCurrentImagePage(page);
    };

    const goToVideoPage = (page) => {
        setCurrentVideoPage(page);
    };

    // Reset pagination when data changes
    useEffect(() => {
        setCurrentImagePage(1);
        setCurrentVideoPage(1);
    }, [galleryImagesArray.length, videosArray.length]);

    const handleImageUpload = async (event) => {
        const files = event.target.files;
        setIsUploading(true);
        try {
            const updatedGalleryImages = [...galleryImagesArray];
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const root = "pharmacy/gallery";
                const status = "public";
                try {

                    const fileId = await OneKlicksFileSDK.uploadFile(root, status, file);
                    if (fileId) {
                        const imageurl = await OneKlicksFileSDK.getfile(fileId.fileId);
                        console.log('imageurl :', imageurl);
                        const newImage = {
                            id: Date.now() + i,
                            name: file.name,
                            url: `${fileId.file.root}/${fileId.file.fileName}`,
                            fileId: fileId.fileId,
                            size: file.size
                        };
                        updatedGalleryImages.push(newImage);
                    } else {
                        console.error("Invalid fileId response:", fileId);
                    }
                } catch (uploadError) {
                    console.error(`Error uploading file ${file.name}:`, uploadError);
                }
            }

            // Update database with new images
            const tableSchema = "";
            const tableName = "pharmacy_gallery";
            const data = {
                images: JSON.stringify(updatedGalleryImages)
            };
            const condition = {
                user_id: await getuserdata("id")
            };

            const updateResult = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateResult.success) {
                throw new Error(updateResult.error || "Failed to update gallery images");
            }

            setGalleryImages(updatedGalleryImages);
        } catch (error) {
            console.error("Error in handleImageUpload:", error);
        } finally {
            setIsUploading(false);
        }
    };

    const handleImageDelete = async (imageId) => {
        const imageToDelete = galleryImagesArray.find(i => i.id === imageId);
        if (!imageToDelete) return;

        const updatedImages = galleryImagesArray.filter(i => i.id !== imageId);
        const previousImages = galleryImagesArray;
        setGalleryImages(updatedImages);

        try {
            const tableSchema = "";
            const tableName = "pharmacy_gallery";
            const data = {
                images: JSON.stringify(updatedImages)
            };
            const condition = {
                user_id: await getuserdata("id")
            };
            const updatedRegistrations = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updatedRegistrations.success) {
                throw new Error(updatedRegistrations.error || "Failed to delete image");
            }
        } catch (error) {
            console.error("Error deleting image:", error);
            setGalleryImages(previousImages);
        }
    };

    const getYouTubeEmbedUrl = (url) => {
        try {
            // Handle youtu.be short URLs
            if (url.includes('youtu.be')) {
                const videoId = url.split('youtu.be/')[1].split('?')[0];
                return `https://www.youtube.com/embed/${videoId}`;
            }
            // Handle youtube.com URLs
            if (url.includes('youtube.com')) {
                const videoId = url.split('v=')[1]?.split('&')[0];
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            }
            return url;
        } catch (error) {
            console.error('Error parsing YouTube URL:', error);
            return url;
        }
    };

    const handleVideoAdd = async () => {
        if (newVideoUrl) {
            console.log("NEW VIDEO URL", newVideoUrl);
            console.log("VIDEOS", videosArray);

            // Check if it's a YouTube URL
            const isYouTubeUrl = newVideoUrl.includes('youtube.com') || newVideoUrl.includes('youtu.be');

            if (isYouTubeUrl) {
                const embedUrl = getYouTubeEmbedUrl(newVideoUrl);
                const updatedVideos = [...videosArray, {
                    id: Date.now(),
                    name: embedUrl,
                    type: 'youtube'
                }];

                // Update database with new videos
                const tableSchema = "";
                const tableName = "pharmacy_gallery";
                const data = {
                    videos: JSON.stringify(updatedVideos)
                };
                const condition = {
                    user_id: await getuserdata("id")
                };

                const updateResult = await oneKlicks.update(tableSchema, tableName, data, condition);
                if (!updateResult.success) {
                    throw new Error(updateResult.error || "Failed to update videos");
                }

                setVideos(updatedVideos);
            } else {
                // Handle local video file
                const file = newVideoUrl;
                if (file) {
                    setIsUploading(true);
                    try {
                        const root = "pharmacy/gallery";
                        const status = "public";

                        const fileId = await OneKlicksFileSDK.uploadFile(root, status, file);
                        if (fileId) {
                            const videoUrl = await OneKlicksFileSDK.getfile(fileId.fileId);
                            const updatedVideos = [...videosArray, {
                                id: Date.now(),
                                name: file.name,
                                type: 'local',
                                url: videoUrl.fileUrl,
                                fileId: fileId.fileId,
                                size: file.size
                            }];

                            // Update database with new videos
                            const tableSchema = "";
                            const tableName = "pharmacy_gallery";
                            const data = {
                                videos: JSON.stringify(updatedVideos)
                            };
                            const condition = {
                                user_id: await getuserdata("id")
                            };

                            const updateResult = await oneKlicks.update(tableSchema, tableName, data, condition);
                            if (!updateResult.success) {
                                throw new Error(updateResult.error || "Failed to update videos");
                            }

                            setVideos(updatedVideos);
                        } else {
                            console.error("Invalid fileId response for video:", fileId);
                        }
                    } catch (error) {
                        console.error("Error uploading video:", error);
                    } finally {
                        setIsUploading(false);
                    }
                }
            }
            setNewVideoUrl("");
        }
    };

    const handleVideoDelete = async (videoId) => {
        const videoToDelete = videosArray.find(v => v.id === videoId);
        if (videoToDelete) {
            try {
                const updatedVideos = videosArray.filter(video => video.id !== videoId);

                // Update database with new videos
                const tableSchema = "";
                const tableName = "pharmacy_gallery";
                const data = {
                    videos: JSON.stringify(updatedVideos)
                };
                const condition = {
                    user_id: await getuserdata("id")
                };

                const updateResult = await oneKlicks.update(tableSchema, tableName, data, condition);
                if (!updateResult.success) {
                    throw new Error(updateResult.error || "Failed to delete video");
                }

            } catch (error) {
                console.error("Error deleting video:", error);
            }
        }
    };

    const handleVideoFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setNewVideoUrl(file);
        }
    };

    const startImportFromFB = async () => {
        const updatedGalleryImages = [...galleryImagesArray];
        console.log("startImportFromFB run");
        const uploadimages = extractImageUrlsFromPage(fbpageurl);
        console.log("uploadimages :", uploadimages);
        const results = [];

        try {
            console.log(`Processing ${uploadimages.length} images`);

            for (let index = 0; index < uploadimages.length; index++) {
                const imgUrl = uploadimages[index];
                try {
                    console.log(`Processing image ${index + 1}/${uploadimages.length}:`, imgUrl);

                    const root = "pharmacy/gallery";
                    const status = "public";
                    const uploadResult = await OneKlicksFileSDK.uploadFileFromUrl(root, status, imgUrl);

                    results.push({
                        index,
                        url: imgUrl,
                        result: uploadResult
                    });

                    console.log(`Image ${index + 1} upload result:`, uploadResult);
                } catch (err) {
                    console.error(`Error uploading image at index ${index}:`, err);

                }
            }

            setGalleryImages(updatedGalleryImages);

            return results;
        } catch (error) {
            console.error("Error in downloadMultipleImages:", error);
            throw error;
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Profile Gallery</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                            <fieldset>
                                <div className="d-flex" style={{ gap: '10px' }}>
                                    {importFromFB ? (
                                        <div className="form-group form-group-label">
                                            <input type="text" className="form-control" placeholder="Enter Facebook page URL" value={fbpageurl} onChange={(e) => setFbpageurl(e.target.value)} />
                                        </div>
                                    ) : (
                                        <div className="form-group form-group-label">
                                            <div className="dc-labelgroup">
                                                <label htmlFor="file" className="dc-image-file">
                                                    <span className="ajax-load dc-btn">Select File</span>
                                                </label>
                                                <span>Drop files here to upload</span>
                                                {isUploading && (
                                                    <em className="dc-fileuploading">
                                                        Uploading<i className="fa fa-spinner fa-spin"></i>
                                                    </em>
                                                )}
                                            </div>
                                            <input
                                                type="file"
                                                multiple
                                                accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                                onChange={handleImageUpload}
                                                style={{ display: 'none' }}
                                                id="file"
                                            />
                                        </div>
                                    )}

                                    <Link to="#" className="dc-btn dc-add_memberships" style={{ width: '100px', height: '50px' }} onClick={() => { importFromFB ? startImportFromFB() : setImportFromFB(true); console.log("importFromFB :", importFromFB) }}>{importFromFB ? "Upload" : "Import from FB"}</Link>
                                </div>

                                <div className="form-group uploaded-placeholder">
                                    <ul className="dc-attachfile dc-attachfilevtwo dc-galler-images">
                                        {currentImages.map((image) => (
                                            <li key={image.id} className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>

                                                        <ImageShow url={image.url} type="doctor" style={{ objectFit: 'cover' }} />
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>{image.name}</span>
                                                        <em>
                                                            File size: {image.size}
                                                            <button type="button" className="dc-remove-gallery-image lnr lnr-cross" onClick={() => handleImageDelete(image.id)}></button>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                    {totalImagePages > 1 && (
                                        <div className="dc-pagination-container" style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '15px',
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderTop: '1px solid #e6e6e6'
                                        }}>
                                            <button
                                                onClick={() => goToImagePage(currentImagePage - 1)}
                                                disabled={currentImagePage === 1}
                                                style={{
                                                    padding: '8px 16px',
                                                    border: '1px solid #ddd',
                                                    backgroundColor: currentImagePage === 1 ? '#f5f5f5' : '#fff',
                                                    color: currentImagePage === 1 ? '#999' : '#333',
                                                    cursor: currentImagePage === 1 ? 'not-allowed' : 'pointer',
                                                    borderRadius: '4px',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                Previous
                                            </button>
                                            <span style={{
                                                fontSize: '14px',
                                                color: '#666',
                                                fontWeight: '500'
                                            }}>
                                                Page {currentImagePage} of {totalImagePages}
                                            </span>
                                            <button
                                                onClick={() => goToImagePage(currentImagePage + 1)}
                                                disabled={currentImagePage === totalImagePages}
                                                style={{
                                                    padding: '8px 16px',
                                                    border: '1px solid #ddd',
                                                    backgroundColor: currentImagePage === totalImagePages ? '#f5f5f5' : '#fff',
                                                    color: currentImagePage === totalImagePages ? '#999' : '#333',
                                                    cursor: currentImagePage === totalImagePages ? 'not-allowed' : 'pointer',
                                                    borderRadius: '4px',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div className="dc-skills dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Videos</h3>
                    </div>
                    <div className="dc-skillscontent-holder">
                        <div className="dc-formtheme dc-skillsform">
                            <fieldset>
                                <div className="form-group">
                                    <div className="form-group-holder">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="input_membership"
                                            placeholder="Enter YouTube URL or select local video"
                                            value={newVideoUrl}
                                            onChange={(e) => setNewVideoUrl(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="form-group-holder">
                                        <input
                                            type="file"
                                            accept="video/*"
                                            onChange={handleVideoFileUpload}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="form-group dc-btnarea">
                                    <a href="#" className="dc-btn dc-add_memberships" onClick={(e) => {
                                        e.preventDefault();
                                        handleVideoAdd();
                                    }}>
                                        Add Now
                                    </a>
                                </div>
                            </fieldset>
                        </div>
                        <div className="dc-myskills">
                            <ul className="sortable list dc-memberships dc-sortable-list">
                                {currentVideos.map((video) => (
                                    <li key={video.id}>
                                        <div className="dc-dragdroptool">
                                            <a href="javascript:" className="lnr lnr-menu"></a>
                                        </div>
                                        <span className="skill-dynamic-html">
                                            <em className="skill-val">
                                                {video.type === 'youtube' ? (
                                                    <div className="youtube-video-container">
                                                        <iframe
                                                            width="280"
                                                            height="157"
                                                            src={video.name}
                                                            title="YouTube video player"
                                                            frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                            allowFullScreen
                                                            onError={(e) => {
                                                                console.error('Error loading YouTube video:', e);
                                                                e.target.style.display = 'none';
                                                                e.target.parentElement.innerHTML = `
                                                                    <div class="video-error">
                                                                        <p>Video unavailable</p>
                                                                        <a href="${video.name}" target="_blank" rel="noopener noreferrer">
                                                                            Open in YouTube
                                                                        </a>
                                                                    </div>
                                                                `;
                                                            }}
                                                        ></iframe>
                                                    </div>
                                                ) : (
                                                    <div className="local-video-container">
                                                        <video
                                                            controls
                                                            width="280"
                                                            height="157"
                                                            src={video.url}
                                                            className="local-video-player"
                                                        >
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    </div>
                                                )}
                                            </em>
                                        </span>
                                        <div className="dc-rightarea">
                                            <a href="#" className="dc-deleteinfo" onClick={(e) => {
                                                e.preventDefault();
                                                handleVideoDelete(video.id);
                                            }}>
                                                <i className="lnr lnr-trash"></i>
                                            </a>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            {totalVideoPages > 1 && (
                                <div className="dc-pagination-container" style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '15px',
                                    marginTop: '20px',
                                    padding: '15px',
                                    borderTop: '1px solid #e6e6e6'
                                }}>
                                    <button
                                        onClick={() => goToVideoPage(currentVideoPage - 1)}
                                        disabled={currentVideoPage === 1}
                                        style={{
                                            padding: '8px 16px',
                                            border: '1px solid #ddd',
                                            backgroundColor: currentVideoPage === 1 ? '#f5f5f5' : '#fff',
                                            color: currentVideoPage === 1 ? '#999' : '#333',
                                            cursor: currentVideoPage === 1 ? 'not-allowed' : 'pointer',
                                            borderRadius: '4px',
                                            fontSize: '14px'
                                        }}
                                    >
                                        Previous
                                    </button>
                                    <span style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        fontWeight: '500'
                                    }}>
                                        Page {currentVideoPage} of {totalVideoPages}
                                    </span>
                                    <button
                                        onClick={() => goToVideoPage(currentVideoPage + 1)}
                                        disabled={currentVideoPage === totalVideoPages}
                                        style={{
                                            padding: '8px 16px',
                                            border: '1px solid #ddd',
                                            backgroundColor: currentVideoPage === totalVideoPages ? '#f5f5f5' : '#fff',
                                            color: currentVideoPage === totalVideoPages ? '#999' : '#333',
                                            cursor: currentVideoPage === totalVideoPages ? 'not-allowed' : 'pointer',
                                            borderRadius: '4px',
                                            fontSize: '14px'
                                        }}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gallery;
